module.exports = __webpack_public_path__ + "static/media/Teams.0e27a834.svg";